
  export default {
    data() {
      return {
        subscriptions: [
          {
            color: '#DEB085',
            name: 'Bronze',
            free_jobs_per_month: 5,
            discount: '10%',
            applicant_export: true,
            price: '50 €',
            number_of_coins: '12.500 pbCoins',
          },
          {
            color: '#CBCBCB',
            name: 'Silver',
            free_jobs_per_month: 13,
            discount: '15%',
            applicant_export: true,
            price: '100 €',
            number_of_coins: '30.000 pbCoins',
          },
          {
            color: '#DCA441',
            name: 'Gold',
            free_jobs_per_month: 22,
            discount: '20%',
            applicant_export: true,
            price: '150 €',
            number_of_coins: '50.000 pbCoins',
          },
        ],
      };
    },
  };
